<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M3.5 17.5 8.25 12l4.25 3 7-8.25"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.75 6.75h3.75v3.75"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="3.5" cy="17.5" r="1.75" fill="currentColor" />
    <circle cx="8.25" cy="12" r="1.75" fill="currentColor" />
    <circle cx="12.5" cy="15" r="1.75" fill="currentColor" />
  </svg>
</template>
